import BankAccountForm from './BankAccountForm'

export default BankAccountForm
